import { InjectionToken } from '@angular/core';
import type { IDialogRef } from './Interfaces/IDialogRef';

/**
 * @public
 * @token
 */
export const DIALOG_REF = new InjectionToken<IDialogRef>('Dialog Ref');
